import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-funeral-parlour-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-funeral-parlour-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { AppControllerService } from "../../../../app-controller.service";
import { ApplicationCreateService } from "../../../../create-application/shared/application-create.service";
import { CreateApplicationViewBaseComponent } from "../../../../create-application/shared/create-application-view-base/create-application-view-base.component";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { CreateFuneralParlourConstants } from "./create-funeral-parlour.constant";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../shared/models/alert";
import { take } from "rxjs/operators";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateFuneralParlourCmComponent = class CreateFuneralParlourCmComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    recipientService;
    selectedApplicationService;
    appControllerService;
    appService;
    changeDetectorRefs;
    recipientFilterService;
    searchApplicationsService;
    parlourForm = new FormGroup({});
    parlourFormGroupName = CreateFuneralParlourConstants.FUNERAL_PARLOUR_IS_NULL_FORM_GROUP_NAME;
    parlourLabel = CreateFuneralParlourConstants.NOTICE_LABEL;
    parlourControl = CreateFuneralParlourConstants.PARLOUR_CONTROL;
    parlourSelectControl = CreateFuneralParlourConstants.PARLOUR_SELECT_CONTROL;
    parlourPh = CreateFuneralParlourConstants.PLACE_HOLDER;
    validationMessages = CreateFuneralParlourConstants.VALIDATION_MESSAGES;
    parlourSelectLabel = CreateFuneralParlourConstants.PARLOUR_SELECT_LABEL;
    title = CreateFuneralParlourConstants.TITLE;
    markFpMotApplicableLabel = CreateFuneralParlourConstants.MARK_FUNERAL_PARLOUR_AS_NOT_APPLICABLE_LABEL;
    funeralParlourIsNullFormControlName = CreateFuneralParlourConstants.FUNERAL_PARLOUR_IS_NULL_FORM_CONTROL_NAME;
    dropdownPlaceHolder = SharedConstants.PLACEHOLDER_TEXT;
    parlourGroups = [];
    parlours;
    parlourMetadata;
    disableEditing = true;
    funeralParlourNotApplicableChecked = false;
    component = "create-funeral-parlour";
    getRecipientsByGroupSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, recipientService, selectedApplicationService, appControllerService, appService, changeDetectorRefs, recipientFilterService, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientService = recipientService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.appService = appService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.recipientFilterService = recipientFilterService;
        this.searchApplicationsService = searchApplicationsService;
        this.getMetadata();
    }
    ngOnInit() {
        this.initForm();
        this.getFuneralParlours();
        this.subscribeToCheckFormValidity();
    }
    loadMetadata(stepMeta) {
        this.parlourMetadata = stepMeta;
        this.parlourGroups = stepMeta.funeralParlourGroup;
        this.changeDetectorRefs.markForCheck();
    }
    onSelectParlour(event) {
        const element = event.target;
        const selectedParlour = this.parlours.find(p => p.id === +element.value);
        this.parlourForm.get(this.parlourControl).clearValidators();
        this.parlourForm.get(this.parlourControl).patchValue(selectedParlour);
        this.parlourForm.get(this.parlourSelectControl).patchValue(selectedParlour.id);
        this.parlourForm.get(this.parlourControl).updateValueAndValidity();
        this.changeDetectorRefs.markForCheck();
    }
    onFuneralParlourNotApplicable($event) {
        const funeralParlourIsNullable = $event.target.checked;
        if (funeralParlourIsNullable) {
            this.funeralParlourNaChecked();
        }
        else {
            this.funeralParlourNANotChecked();
        }
        this.changeDetectorRefs.markForCheck();
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("funeralParlourForm");
        form.clearValidators();
        form.updateValueAndValidity();
        this.parlourForm = form;
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    getFuneralParlours() {
        const recipientSelect = {
            jobId: null,
            moduleId: this.applicationCreateService.moduleID,
            groups: []
        };
        if (this.parlourGroups.length > 0) {
            this.parlourGroups.forEach((group, i) => {
                const ggroup = {
                    groupType: this.propertyDataAlternateColumnName(group, "groupType", "GroupType"),
                    groupName: this.propertyDataAlternateColumnName(group, "groupName", "GroupName"),
                };
                recipientSelect.groups.push(ggroup);
            });
        }
        this.getRecipientsByGroupSubscription =
            this.recipientFilterService.getRecipientsByGroup(recipientSelect).pipe(take(1)).subscribe({
                next: (recipients) => {
                    if (recipients.recipients.length > 0) {
                        this.parlours = recipients.recipients;
                        if (this.parlours.length === 0) {
                            this.appControllerService.showMessage("No funeral parlours found. Please try again or contact your system administrator", AlertType.Error);
                        }
                        this.checkCurrentApplicationForSavedFuneralParlours();
                        this.changeDetectorRefs.markForCheck();
                    }
                },
                error: (error) => {
                    this.appControllerService.handleServerErrorMessage(this.component, error, CRUDOperation.Get);
                }
            });
    }
    funeralParlourNaChecked() {
        this.parlourForm?.get(this.parlourControl).reset();
        this.parlourForm?.get(this.parlourControl).enable();
        this.parlourForm?.get(this.parlourControl).clearValidators();
        this.parlourForm?.get(this.parlourControl).updateValueAndValidity();
        this.parlourForm?.get(this.parlourControl).disable();
        this.parlourForm?.markAsDirty();
        this.parlourForm?.get(this.parlourSelectControl).reset();
        this.parlourForm?.get(this.parlourSelectControl).disable();
        this.parlourForm?.get(this.funeralParlourIsNullFormControlName).setValue(true);
    }
    funeralParlourNANotChecked() {
        this.parlourForm?.get(this.parlourSelectControl).enable();
        this.parlourForm?.get(this.funeralParlourIsNullFormControlName).setValue(false);
    }
    checkCurrentApplicationForSavedFuneralParlours() {
        const application = this.selectedApplication;
        if (application) {
            if (this.parlourForm.pristine) {
                this.syncNotApplicableCheckBox(application);
                if (application.funeralParlour.length > 0) {
                    const funeralParlour = application.funeralParlour[0];
                    const funeralParlourControl = this.parlourForm.get(this.parlourControl);
                    const funeralParlourSelectControl = this.parlourForm.get(this.parlourSelectControl);
                    funeralParlour.groups = this.parlourGroups;
                    funeralParlour.groups.forEach((group) => {
                        if (group?.hasOwnProperty("requiredFields")) {
                            delete group.requiredFields;
                        }
                    });
                    funeralParlourControl.setValue(funeralParlour);
                    funeralParlourSelectControl.setValue(application.funeralParlourId);
                }
            }
            else {
                this.updateNotApplicableCheckBox();
                this.changeDetectorRefs.detectChanges();
            }
        }
    }
    syncNotApplicableCheckBox(application) {
        const funeralParlourNa = application.funeralParlourNa;
        if (funeralParlourNa) {
            this.funeralParlourNotApplicableChecked = true;
            this.parlourForm?.get(this.parlourSelectControl).disable();
            this.parlourForm?.get(this.funeralParlourIsNullFormControlName).setValue(true);
        }
        else {
            this.funeralParlourNotApplicableChecked = false;
            this.parlourForm?.get(this.funeralParlourIsNullFormControlName).setValue(false);
        }
        this.parlourForm?.markAsDirty();
        this.changeDetectorRefs.detectChanges();
    }
    updateNotApplicableCheckBox() {
        const funeralParlourNotApplicable = this.parlourForm.get(this.funeralParlourIsNullFormControlName);
        if (funeralParlourNotApplicable) {
            this.funeralParlourNotApplicableChecked = true;
        }
        else {
            this.funeralParlourNotApplicableChecked = false;
        }
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.parlourForm && formGroupName === this.parlourFormGroupName) {
                    this.parlourForm.markAllAsTouched();
                    this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RecipientService },
        { type: SearchApplicationsService }
    ];
};
CreateFuneralParlourCmComponent = __decorate([
    Component({
        selector: "app-create-funeral-parlour-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateFuneralParlourCmComponent);
export { CreateFuneralParlourCmComponent };
